import { connect } from 'react-redux';
import { hideModal } from '../../reducers/modalReducer';

import CustomerTypeMismatchModelContent from './customer_type_mismatch_model_content';
import { getSecondaryColor } from '../../selectors/configSelectors';

const mapStateToProps = state => ({
  secondaryColor: getSecondaryColor(state),
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTypeMismatchModelContent);



// WEBPACK FOOTER //
// ./src/components/CustomerTypeMismatchModelContent/customer_type_mismatch_model_content_container.jsx